module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-10.da631809.jpg";